"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsList = void 0;
const React = require("react");
const ComponentContainer_1 = require("./component/ComponentContainer");
const ComponentsList = ({ components, renderExample }) => (React.createElement("div", null, components.map((component) => (React.createElement(ComponentContainer_1.ComponentContainer, Object.assign({ renderExample: renderExample }, component))))));
exports.ComponentsList = ComponentsList;
//# sourceMappingURL=ComponentsList.js.map